module.exports = __webpack_public_path__ + "img/parliament-5.2c013b21.jpg";